import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { analyticsApi, type BIDashboard } from '../../api/analytics';

export function ExecutiveDashboardPage() {
  const [dashboard, setDashboard] = useState<BIDashboard | null>(null);
  const [error, setError] = useState('');

  useEffect(() => {
    void analyticsApi.biDashboard(undefined, 'executive').then(setDashboard).catch((e) => setError(String(e)));
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">Executive Dashboard</h1>
        <Link to="/analytics/bi" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← BI Hub</Link>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      {dashboard?.executive && (
        <div className="mt-6 space-y-4">
          <div className="rounded-xl border p-4 dark:border-slate-700">
            <h2 className="text-lg font-medium">{dashboard.executive.headline}</h2>
            <p className="mt-2 text-sm text-slate-600 dark:text-slate-400">{dashboard.executive.summary}</p>
            <p className="mt-2 text-xs text-slate-500">Confidence: {(dashboard.executive.confidence * 100).toFixed(0)}%</p>
          </div>
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="rounded-xl border p-4 dark:border-slate-700">
              <h3 className="font-medium text-green-700 dark:text-green-400">Key Wins</h3>
              <ul className="mt-2 list-inside list-disc text-sm">{dashboard.executive.key_wins?.map((w) => <li key={w}>{w}</li>)}</ul>
            </div>
            <div className="rounded-xl border p-4 dark:border-slate-700">
              <h3 className="font-medium text-amber-700 dark:text-amber-400">Key Risks</h3>
              <ul className="mt-2 list-inside list-disc text-sm">{dashboard.executive.key_risks?.map((r) => <li key={r}>{r}</li>)}</ul>
            </div>
          </div>
        </div>
      )}
      <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
        {dashboard?.kpis?.slice(0, 8).map((k) => (
          <div key={k.key} className="rounded-lg border p-3 dark:border-slate-700">
            <p className="text-xs text-slate-500">{k.name}</p>
            <p className="mt-1 text-lg font-semibold">{k.unit === '%' ? `${k.value.toFixed(1)}%` : k.value.toLocaleString()}</p>
            {k.change !== undefined && <p className={`text-xs ${k.change >= 0 ? 'text-green-600' : 'text-red-600'}`}>{k.change >= 0 ? '+' : ''}{k.change.toFixed(1)}%</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
